import * as React from 'react'

function SvgShieldCheckedIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="m32.293 8.293 1.414 1.414L28 15.414l-3.707-3.707 1.414-1.414L28 12.586l4.293-4.293Z"
        fill="#2EC40B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
        fill="#2EC40B"
      />
      <path
        d="M20 11c0-.655.07-1.294.203-1.91L20 9l-9 4v6c0 5.55 3.84 10.74 9 12 4.849-1.184 8.532-5.838 8.959-11a9.027 9.027 0 0 1-1.976-.227C26.722 23.914 23.59 28.043 20 29c-3.75-1-7-5.46-7-9.78V14l7-3Z"
        fill="#000"
      />
    </svg>
  )
}

export default SvgShieldCheckedIcon
